import React, { FC } from 'react';

export const CaretRight: FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path
      d="M2.25 10.998h15.59l-5.02-5.02a.996.996 0 1 1 1.41-1.41l7.43 7.43-7.43 7.43c-.2.2-.45.29-.71.29-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l5.02-5.02H2.25v-2Z"
    />
  </svg>
);
